import { ZodError, prettifyError } from 'zod';

export default function errorToString(error: unknown) {
    if (error instanceof ZodError) {
        return prettifyError(error);
    }

    if (error instanceof Error) {
        return error.message;
    }

    if (error instanceof Object) {
        return JSON.stringify(error);
    }

    return String(error);
}
